import enigma from 'enigma.js'
import WebSocket from 'ws'
import { logger } from '~/utils/logger'

export default async function qix_global({ app }) {
  const qix = app.$qix //.getQIXConfig({ env: app.$env })
  var mergedcredentials = {}

  if (process.server) {
    //Websocket needs to be opened for code that is rendered server side, but doesn't need to be opened for code rendered client side.
    logger.debug('Server Mode')

    if (app.$env.isLocal) {
      logger.debug('Dev environment detected')

      const certificatesPath = app.$config.certPath

      const fs = require('fs')
      const path = require('path')

      const nondevroot = !app.$env.isLocal
        ? { ca: fs.readFileSync(path.resolve(certificatesPath, 'root.pem')) }
        : ''
      const keycert = {
        key: fs.readFileSync(path.resolve(certificatesPath, 'server.key')),
        cert: fs.readFileSync(path.resolve(certificatesPath, 'server.crt')),
        headers: {
          //'X-Qlik-User': 'UserDirectory=DIRECTIT;UserId=svc-dev-qap'
          'X-Qlik-User': 'UserDirectory=INTERNAL;UserId=sa_repository'
        }
      }
      mergedcredentials = { ...nondevroot, ...keycert }
      logger.debug(', credentials passed to websocket: ', mergedcredentials)
    } else {
      logger.debug('Prod environment detected')
      mergedcredentials = {
        headers: {
          'X-Qlik-User': 'UserDirectory=INTERNAL;UserId=sa_repository'
        }
      }
    }
  } else {
    logger.debug('Client Mode')
  }

  qix.createSocket = () => new WebSocket(qix.url, [], mergedcredentials)

  logger.debug('About to call asyncData with qix: ', qix)
  logger.debug('Merged Credentials: ', mergedcredentials)

  try {
    const { session, app_session } = await connectWithRetry({ qix: qix })

    return { engine: app_session, session }
  } catch (err) {
    logger.error('Fatal: could not establish engine session after retries', err)
    process.exit(1) // let your process manager (PM2, systemd, k8s) restart the whole process
  }
}

async function connectWithRetry({ qix, maxAttempts = 5, baseDelayMS = 1000 }) {
  let attempts = 0

  while (attempts < maxAttempts) {
    logger.debug(`Attempt ${attempts + 1} to establish engine connection...`)
    try {
      const result = await asyncData(qix)
      logger.debug('Successfully connected to QIX engine.')
      return result
    } catch (err) {
      attempts++

      if (!isRetryable(err) || attempts >= maxAttempts) {
        logger.error(
          `Engine connection failed after ${attempts} attempts. No more retries.`,
          err.message
        )
        throw err
      }

      const delay = baseDelayMS * 2 ** (attempts - 1)

      logger.warn(
        'Engine connection failed (attempt ${attempts}/${maxRetries}), retrying in ${delay}ms...',
        err.message
      )
      await new Promise(resolve => setTimeout(resolve, delay))
    }
  }
}

function isRetryable(err) {
  // Network-level / connection-refused / timeout errors are usually transient
  const retryableCodes = ['ECONNREFUSED', 'ETIMEDOUT', 'ECONNRESET']
  return retryableCodes.includes(err.code) || err.message?.includes('WebSocket')
}

async function asyncData(qix) {
  try {
    const session = enigma.create(qix)

    const global = await session.open()

    const app_session = await global.openDoc(qix.appId)

    logger.debug('Server:app_session', app_session)
    return { session, app_session }
  } catch (err) {
    logger.error('An unexpected error thrown:', err)

    throw err
  }
}

//export default qix_global
